<template lang="pug">
div(:class="[$style.recentMovesSection, {'has-landscape-images': hasLandscapeImages(block)}]")
  Block(
    v-show="block.innerBlocks.length"
    v-for="(innerBlock, key) in block.innerBlocks"
    v-bind="{ id: 'recent-moves-block' + '-' + key, class: 'recent-moves-block' }"
    :key="`recentMovesBlock${key}`"
    :block="innerBlock"
    :block-id="blockId")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getBlockAttribute } from "~/utils/block"

export default defineComponent({
  name: "RecentMovesSection",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    },
    blockId: {
      type: String,
      default: ""
    }
  },

  data() {
    return {}
  },

  methods: {
    hasLandscapeImages(block: Block): boolean {
      return getBlockAttribute(block.attributes, "className").includes("landscape-image")
    }
  }
})
</script>

<style lang="css" module>
.recentMovesSection {
  @apply text-base text-base-dark w-full;
  width: calc(100vw - 16px); /** view width less right padding */

  > *:nth-child(1) {
    @apply mb-ds-lg mt-ds-md;
  }

  :global {
    .av-heading {
      @apply m-0;
    }
    .av-buttons {
      @apply mt-ds-lg;
    }
    .buttons {
      @apply mr-ds-md;
    }
    .img-frame {
      @apply py-0;
    }
    .text-content {
      @apply p-ds-md;

      h3 {
        @apply pt-ds-ml text-start text-rebrandXm;
        margin: 0 0 5px 0;
      }

      .copy-container {
        @apply flex box-border mt-ds-md;
      }
    }
  }

  &:global(.has-landscape-images) {
    :global(.img-frame) {
      @apply py-ds-md;
    }
  }

  > *:nth-child(3) {
    @apply mt-ds-lg mr-ds-md;
  }
}

@screen md {
  .recentMovesSection {
    width: calc(100vw - 32px);

    :global {
      .av-button {
        width: 100%;
      }
      .buttons {
        @apply mr-ds-lg;
      }
    }

    > *:nth-child(3) {
      @apply mr-ds-lg mt-ds-lg;
    }
  }
}

@screen lg {
  .recentMovesSection {
    width: calc(100vw + 80px);
    @apply grid gap-x-ds-xxl;
    grid-template-columns: minmax(310px, 400px) 1fr;
    grid-template-rows: auto max-content;
    grid-template-areas:
      "header carousel"
      "content carousel";

    > *:nth-child(1) {
      @apply mt-ds-lg mb-0;
      grid-area: header;
    }

    > *:nth-child(2) {
      grid-area: carousel;
    }

    > *:nth-child(3) {
      @apply mx-0 mb-ds-xxl;
      grid-area: content;
    }

    :global {
      .av-heading {
        @apply text-left;
      }

      .av-button {
        width: inherit;
      }
    }
  }
}

@screen xl {
  .recentMovesSection {
    grid-template-columns: minmax(200px, 460px) 1fr;
    width: calc(100vw + 96px);
  }
}

@screen rebrandLg {
  .recentMovesSection {
    width: calc(50vw + 660px);
  }
}
</style>
